<template>
    <div>
        <div class="vx-col w-full mb-base">
            <vs-card title="Add New Client" class="p-4 mb-6">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <div class="flex items-center">
                        <vs-button radius color="primary" icon="keyboard_backspace" @click="back"></vs-button>
                        <h4 style="margin-left: 10px">View Invoice Client</h4>
                    </div>
                    <div class="flex">
                        <vs-button
                            color="primary"
                            class="btn mb-4 md:mb-0 mr-1"
                            @click="submitForm"
                            v-show="editMode"
                        >Save</vs-button>
                        <vs-button
                            color="primary"
                            class="btn mb-4 md:mb-0 mr-1"
                            @click="editForm"
                            v-show="!editMode"
                        >Edit</vs-button>
                    </div>
                </div>
                <vs-tabs>
                    <vs-tab label="Details">
                        <div class="vx-row mt-8">
                            <div class="vx-col md:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Invoice ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input disabled class="w-full" v-model="data.id" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Reference
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <vs-input class="w-full" v-model="data.reference" :disabled="!editMode" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Invoice Date
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="data.invoice_date" :disabled="!editMode" />
                                    </div>
                                </div>
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Submit Date
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <flat-pickr class="w-full" v-model="data.submit_date" :disabled="!editMode" />
                                    </div>
                                </div>
                            </div>

                            <div class="vx-col md:w-1/2 w-full">
                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Client ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="clientOption"
                                            v-model="data.client_id"
                                            label="client_code"
                                            @search="searchClient"
                                            :clearable="false"
                                            :disabled="!editMode"
                                        ></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        PO Number
                                    </div>
                                    <div class="vx-col w-2/3">
                                       <vs-input class="w-full" v-model="data.po_number" :disabled="!editMode" />
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-2/3">
                                       <div class="vx-row">
                                            <div class="vx-col w-2/5">
                                                Tax Note
                                            </div>
                                            <div class="vx-col" style="padding:0 1rem 0 1px">
                                            <vs-input class="w-full" v-model="data.tax_note" :disabled="!editMode" />
                                            </div>
                                        </div>
                                    </div>
                                    <div class="vx-col w-1/3">
                                        <div class="vx-row">
                                            <div class="vx-col w-1/4">
                                                VAT
                                            </div>
                                            <div class="vx-col w-1/2">
                                            <vx-input-group :disabled="!editMode" >
                                                <vs-input v-model="data.vat" :disabled="!editMode" />
                                                <template slot="append">
                                                    <div class="append-text bg-primary">
                                                    <span>%</span>
                                                    </div>
                                                </template>
                                            </vx-input-group>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Contract Type ID
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <v-select
                                            :options="contractTypeOption"
                                            v-model="data.contract_type_id"
                                            label="contract_type"
                                            @search="searchContractType"
                                            :clearable="false"
                                            :disabled="!editMode"
                                        ></v-select>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Schedule Date
                                    </div>
                                    <div class="vx-col w-2/3">
                                        <div class="vx-row w-full">
                                            <div class="vx-col md:w-1/3 ">
                                                <flat-pickr class="w-full" v-model="data.date_start" :disabled="!editMode"/>
                                            </div>
                                            <div class="vx-col md:w-1/12">
                                            To
                                            </div>
                                            <div class="vx-col md:w-1/3 ">
                                                <flat-pickr class="w-full" v-model="data.date_end" :disabled="!editMode" />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Manifest Amount
                                    </div>
                                    <div class="vx-col w-2/3">
                                       <vs-input disabled class="w-full" v-model="data.manifest_amount" />
                                    </div>
                                </div>

                                <div class="vx-row mb-3">
                                    <div class="vx-col w-1/4">
                                        Total Amount
                                    </div>
                                    <div class="vx-col w-2/3">
                                       <vs-input disabled class="w-full" v-model="data.total_amount" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Remark">
                        <div class="vx-row mt-6">
                            <div class="vx-col w-full">
                                <vs-textarea v-model="data.remark" label="Remark" height="200" :disabled="!editMode"/>
                            </div>
                        </div>
                    </vs-tab>
                    <vs-tab label="Attcahment">
                    </vs-tab>
                </vs-tabs>
            </vs-card>
            <vs-card class="p-4">
                <div slot="header" class="flex flex-wrap items-center justify-between">
                    <h4>Invoice Details</h4>
                    <div class="flex">
                        <vs-button @click="addItem()" class="btn mb-4 md:mb-0 mr-1" :disabled="( data.client_id == null && data.contract_type_id == null) || !editMode">Add</vs-button>
                        <vs-button @click="removeItem()" class="btn mb-4 md:mb-0 mr-1" :disabled="selectedDetails.length <= 0 || !editMode">Remove</vs-button>
                    </div>
                </div>
                <div style="overflow-y: auto;" class="mt-6">
                    <vs-table v-model="selectedDetails" :data="dataDetails" multiple hoverFlat>
                        <template slot="thead">
                        <th style="width: 15%">Manifest ID</th>
                        <th style="width: 20%">Reference</th>
                        <th style="width: 15%">Schedule Date</th>
                        <th style="width: 10%">Trip</th>
                        <th style="width: 10%">Vehicle Name</th>
                        <th style="width: 15%">Vehicle Type</th>
                        <th style="width: 15%">Ammount</th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="tr.id">
                                {{ tr.id }}
                                </vs-td>
                                <vs-td :data="tr.tro_reference">
                                {{ tr.tro_reference }}
                                </vs-td>
                                <vs-td :data="tr.schedule_date">
                                {{ tr.schedule_date }}
                                </vs-td>
                                <vs-td :data="tr.trip">
                                {{ tr.trip }}
                                </vs-td>
                                <vs-td :data="tr.vehicle_code">
                                {{ tr.vehicle_code }}
                                </vs-td>
                                <vs-td :data="tr.vehicle_type">
                                {{ tr.vehicle_type }}
                                </vs-td>
                                <vs-td :data="tr.fixed_rate">
                                {{ tr.fixed_rate }}
                                </vs-td>
                            </vs-tr>
                        </template>

                    </vs-table>
                </div>
            </vs-card>
        </div>


        <!-- start-route-history -->
        <vs-popup title="Select Manifest" :active.sync="showRoute" id="myPopup">
                <div class="row pb-5">
                    <vs-table v-model="selectedManifest" :data="dataManifest" multiple hoverFlat>
                        <template slot="thead">
                        <th style="width: 15%">Manifest ID</th>
                        <th style="width: 20%">Reference</th>
                        <th style="width: 15%">Schedule Date</th>
                        <th style="width: 10%">Trip</th>
                        <th style="width: 10%">Vehicle Name</th>
                        <th style="width: 15%">Vehicle Type</th>
                        <th style="width: 15%">Ammount</th>
                        </template>

                        <template slot-scope="{data}">
                            <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                                <vs-td :data="tr.id">
                                {{ tr.id }}
                                </vs-td>
                                <vs-td :data="tr.tro_reference">
                                {{ tr.tro_reference }}
                                </vs-td>
                                <vs-td :data="tr.schedule_date">
                                {{ tr.schedule_date }}
                                </vs-td>
                                <vs-td :data="tr.trip">
                                {{ tr.trip }}
                                </vs-td>
                                <vs-td :data="tr.vehicle_code">
                                {{ tr.vehicle_code }}
                                </vs-td>
                                <vs-td :data="tr.vehicle_type">
                                {{ tr.vehicle_type }}
                                </vs-td>
                                
                                <vs-td :data="tr.fixed_rate">
                                {{ tr.fixed_rate }}
                                </vs-td>
                            </vs-tr>
                        </template>

                    </vs-table>
                </div>

            <div class="flex flex-wrap justify-end mt-5">
                <div class="flex items-center">
                    <vs-button class="mb-4 md:mb-0" @click="addItemToDetails" color="primary" :disabled="selectedManifest.length <= 0" >Add</vs-button>
                </div>
            </div>
        </vs-popup>
        <!-- start-route-history -->


    </div>
</template>

<script>
import vSelect from "vue-select";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";

export default {
    components: {
        vSelect,
        flatPickr
    },
    data() {
        return {
            isLoading: false,
            editMode:false,
            data: {
                id: '',
                reference: '',
                invoice_date:null,
                submit_date:null,
                status: "",

                client_id: null,
                contract_type_id: null,
                date_start:null,
                date_end:null,
                po_number:'',
                vat:1,
                tax_note:'',

                remark: "",
            },

            dataDetails:[],
            selectedDetails:[],

            vatAmount:0,
            manifestAmount:0,
            totalAmount:0,

            showRoute:false,
            selectedManifest:[],
            dataManifest:[],

            clientOption:[],
            contractTypeOption:[],

            maxRetry: 10
        };
    },
    watch: {
        isLoading: function() {
            if (this.isLoading) {
                this.$vs.loading();
            } else {
                this.$vs.loading.close();
            }
        }
    },
    methods: {
        addItemToDetails(){
            this.showRoute = false
            this.manifestAmount = 0
            // this.selectedManifest.map((item, index)=>{
            //     // this.selectedManifest.splice(index, 1)
            // })
            for(const [index, data] of this.selectedManifest.entries()){
                let item = data
                this.manifestAmount += parseFloat(data.fixed_rate)
                this.dataDetails.push(item)
            }
            this.data.manifest_amount = this.manifestAmount;
            this.calculateAmount();
        },
        removeItem(){
            for(const [index, data] of this.selectedDetails.entries()){
                this.dataDetails.splice(index, 1)
            }
        },
        addItem(){
            let data = {
                contract_type:this.data.contract_type_id.contract_type,
                client:this.data.client_id.client_code
            }
            this.dataManifest = []
            this.$http.post("transport/invoiceclient/routed-manifest", data)
            .then(res => {
                this.selectedManifest = []
                this.showRoute = true;
                this.dataManifest = res.data;
            })
            .catch((error) => {
                console.log(error)
            });
        },
        fetchData(api) {
            return this.$http.get(api);
        },
        searchClient(search, loading) {
            if (search.length > 2) {
                loading(true);
                const data = {
                    name: search
                };
                this.$http
                    .post("master/clients", data)
                    .then(res => {
                        this.clientOption = res.data;
                        loading(false);
                    })
                    .catch(() => {
                        this.searchClient(search, loading);
                    });
            }
        },

        searchContractType(search, loading) {
            if (search.length > 2) {
                loading(true);
                const data = {
                    name: search
                };
                this.$http
                    .post("master/vehicletypes/filter/search", data)
                    .then(res => {
                        this.clientOption = res.data;
                        loading(false);
                    })
                    .catch(() => {
                        this.searchContractType(search, loading);
                    });
            }
        },
        calculateAmount() {
          this.vatAmount = this.data.vat * this.data.manifest_amount / 100;
          this.data.total_amount = this.data.manifest_amount + this.vatAmount;
        },
        submitForm() {
            if(this.data.client_id == null){
                this.$vs.notify({
                    color: "danger",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "client field required"
                    });
                    return false ;
            }

            if(this.data.contract_type_id == null){
                this.$vs.notify({
                    color: "danger",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "contract type field required"
                    });
                    return false ;
            }

            let header = Object.assign({},this.data) 
            this.isLoading = true;

            header.client_id = this.data.client_id.id 
            header.contract_type_id = this.data.contract_type_id.id 
            header.manifest_amount = this.data.manifest_amount
            header.invoice_amount = this.data.total_amount

            let data = {
                invoice_header:JSON.stringify(header),
                invoice_details: JSON.stringify(this.dataDetails)
            }; 

            this.$http
            .post("transport/invoiceclient/"+this.data.id+"/update", data)
            .then(res => {
                this.$vs.notify({
                    color: "success",
                    title: "Saved Successfully",
                    iconPack: "feather",
                    icon: "icon-check",
                    text: "Invoice Client updated"
                });
                this.$router.push({ name: "invoiceclient" });
            })
            .catch(error => {
                this.isLoading = false;
                for (const [index, err] of error.response.data.entries()) {
                    this.$vs.notify({
                        color: "danger",
                        iconPack: "feather",
                        icon: "icon-x",
                        text: "" + err
                    });
                }
            })
            .then(() => {
                this.isLoading = false;
            });
        },
        back() {
            if (this.editMode) {
                this.$vs.dialog({
                    color: "warning",
                    title: "Leave Page",
                    text: "Changes you made may not be saved?",
                    acceptText: "Leave Page",
                    accept: () => this.$router.go(-1)
                });
            } else {
                this.$router.go(-1);
            }
        },
        fetchAllData(){
              this.$http
                .all([
                    this.$http.get("transport/invoiceclient/"+this.$route.params.id),
                ])
                .then(
                    this.$http.spread(
                        (
                            invoice,
                        ) => {
                            this.data = invoice.data.invoice_header;
                            this.dataDetails = invoice.data.invoice_details;
                            this.data.client_id = invoice.data.invoice_header.client
                            this.data.contract_type_id = invoice.data.invoice_header.contract_type
                            this.data.manifest_amount = invoice.data.invoice_header.manifest_amount
                            this.data.total_amount = invoice.data.invoice_header.invoice_amount
                            this.clientOption = [invoice.data.invoice_header.client]
                            this.contractTypeOption = [invoice.data.invoice_header.contract_type]
                            setTimeout(() => {
                                this.isLoading = false;
                            }, 500);
                        }
                    )
                )
                .catch(() => {
                    this.maxRetry-- 
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.fetchAllData();
                                this.maxRetry = 10;
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchAllData();
                });
        },
        editForm() {
            this.isLoading = true;
            this.maxRetry = this.maxRetry - 1;
            this.$http
                .all([
                    this.$http.post("master/clients"),
                    this.$http.post("master/contracttypes"),
                ])
                .then(
                    this.$http.spread(
                        (
                            clients,
                            contracttypes,
                        ) => {
                            this.clientOption = clients.data.data;
                            this.contractTypeOption = contracttypes.data.data;
                            setTimeout(() => {
                                this.isLoading = false;
                                this.editMode = true;
                            }, 500);
                        }
                    )
                )
                .catch(() => {
                    if (this.maxRetry == 0) {
                        this.isLoading = false;
                        this.$vs.dialog({
                            type: "confirm",
                            color: "danger",
                            title: "Server Error",
                            text: "Try again?",
                            accept: () => {
                                this.fetchAllData();
                                this.maxRetry = 10;
                            },
                            cancel: () => this.$router.go(-1),
                            acceptText: "Yes",
                            cancelText: "No"
                        });
                        return;
                    }
                    this.fetchAllData();
                });
        }
    },
    mounted() {
        this.fetchAllData();
        let dt = new Date();
        let year = dt.getFullYear();
        let month = dt.getMonth();
        let day = dt.getDate();
        this.data.date_end = `${year}-${month}-${day}`
        this.data.date_start = `${year}-${month}-${day}`
    }
};
</script>


<style type="text/css">

    #myPopup.con-vs-popup .vs-popup {
        width: 1200px;
    }
    #myPopup2.con-vs-popup .vs-popup {
        width: 85%;
    }

</style>